import { useEffect, useRef, useState } from "react";
import { WifiOff, Wifi } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";

/**
 * Fixed banner that shows when the user goes offline,
 * and a brief animated "Wieder online" toast when reconnecting.
 */
export function OfflineBanner() {
  const isOnline = useOnlineStatus();
  const [showReconnect, setShowReconnect] = useState(false);
  const wasOffline = useRef(false);

  useEffect(() => {
    if (!isOnline) {
      wasOffline.current = true;
      return;
    }
    if (wasOffline.current) {
      setShowReconnect(true);
      const t = setTimeout(() => setShowReconnect(false), 2400);
      wasOffline.current = false;
      return () => clearTimeout(t);
    }
  }, [isOnline]);

  if (!isOnline) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="fixed left-0 right-0 z-[60] flex items-center justify-center gap-2 bg-destructive text-destructive-foreground text-xs font-bold py-2 px-4 shadow-md animate-in slide-in-from-top duration-200 motion-reduce:animate-none"
        style={{ top: "env(safe-area-inset-top, 0px)" }}
      >
        <WifiOff className="w-3.5 h-3.5" />
        Keine Internetverbindung – einige Funktionen sind eingeschränkt
      </div>
    );
  }

  if (showReconnect) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="fixed left-0 right-0 z-[60] flex items-center justify-center gap-2 bg-emerald-600 text-white text-xs font-bold py-2 px-4 shadow-md animate-in slide-in-from-top fade-in duration-300 motion-reduce:animate-none"
        style={{ top: "env(safe-area-inset-top, 0px)" }}
      >
        <Wifi className="w-3.5 h-3.5" />
        Wieder online ✓
      </div>
    );
  }

  return null;
}

export default OfflineBanner;
